import React from 'react'
import { Link } from 'react-router'
import styles from './HomepageSideNav.scss'
import { LoadableOrganizations } from '../../Organizations'
import { SideNav, SideNavHeader, SideNavExtras, SideNavActions, SideNavAction } from 'common/layouts/SideNavLayout/SideNav'
import { ProfileImg } from 'common/ProfileImg'
import { AccountTypeBadge } from 'common/AccountTypeBadge'
import { currentUserHasPrivilege, DASH_LAUNCH } from 'lib/utils'
import { fm, featureNames } from 'lib/localization'
import cx from 'classnames'
import _ from 'lodash'
import { defineMessages, injectIntl } from 'react-intl'

const hpsnMessages = defineMessages({
  returnClassic: {
    id: 'hpsnMessages.returnClassic',
    defaultMessage: 'Return to Classic Profile View'
  }
})

const _HomepageSideNav = ({ user, collapseState, intl }) => {
  const isMobile = collapseState === 'viewport' || collapseState === 'viewport-expanded'
  const legacyUser = user.createdAt < DASH_LAUNCH
  const home = (user.preferences && user.preferences.get('dashboard_home')) || 'dashboard'
  const pathParams = path => ({ to: home === path ? '/' : `/${path}`, index: home === path })
  const canSeeRideCenter = currentUserHasPrivilege('activity_center')
  const links = [
    { title: fm(intl, featureNames.dashboard), ...pathParams('dashboard'), icon: 'md-home', id: 'dashboard-nav-home' },
    { title: isMobile
      ? _.capitalize(fm(intl, featureNames.events, { count: 0 }))
      : fm(intl, featureNames.calendar),
    ...pathParams('calendar'),
    icon: 'md-calendar' },
    { title: fm(intl, featureNames.routes), ...pathParams('routes'), icon: 'md-pin' },
    { title: _.capitalize(fm(intl, featureNames.rides)), ...pathParams('rides'), icon: 'md-bicycle' },
    { title: fm(intl, featureNames.collections), ...pathParams('collections'), icon: 'dynamic-feed' },
    canSeeRideCenter
      ? { title: fm(intl, featureNames.analyze), href: '/activities', icon: 'md-trending-up', id: 'dashboard-nav-analyze' }
      : { title: fm(intl, featureNames.analyze), to: '/analyze', icon: 'md-trending-up', id: 'dashboard-nav-analyze' },
    { title: fm(intl, featureNames.upload), to: '/upload', icon: 'upload-arrow' },
    { title: fm(intl, featureNames.friends), ...pathParams('friends'), icon: 'md-people', id: 'dashboard-nav-friends' },
    { title: fm(intl, featureNames.more), ...pathParams('more'), icon: 'md-apps', id: 'dashboard-nav-more' }
  ].filter(l => l)

  return <SideNav links={links}>
    <SideNavHeader>
      <div className={cx(styles.userCard, collapseState && styles.userCardCollapsed)}>
        <Link to={`/users/${user.id}`}>
          <ProfileImg
            sidebarHeader
            user={user}
            className={styles.profileImg} />
        </Link>
        {!collapseState && <h2 className={styles.displayName}>{user.name} <AccountTypeBadge accountLevel={user.accountLevel} size={14} /></h2>}
      </div>
    </SideNavHeader>

    <SideNavExtras>
      <LoadableOrganizations currentUser={user} collapsed={collapseState} />
    </SideNavExtras>

    <SideNavActions>
      {legacyUser && !collapseState && <SideNavAction id='dashboard-nav-classic-profile' href={`/users/${user.id}?beta=false`} label={fm(intl, hpsnMessages.returnClassic)} />}
    </SideNavActions>
  </SideNav>
}

export const HomepageSideNav = injectIntl(_HomepageSideNav)
